import { useEffect, useState } from "react";

const Timer = () => {
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(true);

  useEffect(() => {
    if(isRunning){
        const interval = setInterval(() => {
          setTime((prevTime) => prevTime + 1);
        }, 1000);
    
        return () => clearInterval(interval);
    }
  }, [isRunning]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    // Format numbers to always show two digits
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  return <div className="countdown">{formatTime(time)}</div>;
};

export default Timer;
